import { z } from "zod";

import {
	quoteBodySchema,
	quoteShipmentBodySchema,
} from "~/shared/schemas/quote-schema.ts";

// Request body for POST /api/shipment-details/ltl-tender-flow.
// Combines the create-quote and update-shipment-details operations
// from the legacy quoting flow into a single command.

export const saveInsuranceSelectionSchema = z.object({
	insuranceValue: z.number(),
	insuranceProductTypeId: z.number(),
});

export const ltlTenderFlowBodySchema = z.object({
	createQuote: quoteBodySchema,
	updateShipmentDetails: quoteShipmentBodySchema,
	saveInsuranceSelection: saveInsuranceSelectionSchema.optional(),
	// True when the freight class sent to the backend is the system-estimated
	// class (e.g. a vendor left the class blank) rather than a user selection.
	estimatedFreightClassIdProvided: z.boolean(),
});

export type LtlTenderFlowBody = z.infer<typeof ltlTenderFlowBodySchema>;
